module.exports = __webpack_public_path__ + "static/media/login_fundo.80fe2cf1.png";